import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { ApiListParams, ApiListResponse } from '@core/api/api.model';
import { objectToFormData } from '@core/helpers/form-data';
import {
  IOrgUser,
  IOrgUserDetail,
  IOrgUserSaveRequest,
  IUserAllocation,
  IUserAllocationOption,
} from './org-user.model';

@Injectable({ providedIn: 'root' })
export class OrgUserApi {
  private readonly http = inject(HttpClient);

  getUsers(params: ApiListParams): Observable<ApiListResponse<IOrgUser>> {
    return this.http.get<ApiListResponse<IOrgUser>>(`${environment.api}accounts/`, {
      params: params as Record<string, string | number | boolean>,
    });
  }

  getUser(id: number): Observable<IOrgUserDetail> {
    return this.http.get<IOrgUserDetail>(`${environment.api}accounts/${id}/`);
  }

  createUser(input: IOrgUserSaveRequest, allocation: IUserAllocation): Observable<IOrgUserDetail> {
    let params = new HttpParams();
    if (allocation.plan != null) params = params.set('plan', allocation.plan);
    if (allocation.product != null) params = params.set('product', allocation.product);
    return this.http.post<IOrgUserDetail>(
      `${environment.api}accounts/`,
      objectToFormData({ ...input }),
      { params },
    );
  }

  updateUser(id: number, input: IOrgUserSaveRequest): Observable<IOrgUserDetail> {
    return this.http.put<IOrgUserDetail>(
      `${environment.api}accounts/${id}/`,
      objectToFormData({ id, ...input }),
    );
  }

  deleteUser(id: number): Observable<void> {
    return this.http.delete<void>(`${environment.api}accounts/${id}/`);
  }

  getAllocationPlans(): Observable<IUserAllocationOption[]> {
    return this.http.get<IUserAllocationOption[]>(`${environment.api}invoices/plans/`);
  }

  getAllocationProducts(): Observable<IUserAllocationOption[]> {
    return this.http.get<IUserAllocationOption[]>(`${environment.api}invoices/products/`);
  }
}
